module.exports = __webpack_public_path__ + "static/media/studio-etc13.f038cbb8.png";